import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const FOOTER_LINKS = [
  { to: "/pacchetti", label: "Pacchetti" },
  { to: "/calcolatore-roi", label: "Calcolatore ROI" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/carrello", label: "Carrello" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-lineblue bg-surface/40">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Produzione video e advertising per TikTok, Instagram e Facebook.
            Dieci pacchetti dedicati per brand che vogliono fermare lo scroll.
          </p>
        </div>

        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-electric">
            Navigazione
          </p>
          <ul className="mt-5 space-y-3">
            {FOOTER_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-slate-300 transition-colors duration-300 hover:text-electric"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-company-data">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-electric">
            Società
          </p>
          <ul className="mt-5 space-y-2 text-sm text-slate-300">
            <li className="font-semibold text-white">KING TECH SRLS</li>
            <li>Via Nazionale, 79 — Corigliano-Rossano (CS)</li>
            <li>P.IVA / C.F. 03933680781</li>
            <li>REA 266638 · ATECO 47.91.1</li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-lineblue pt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          © {new Date().getFullYear()} CINEBLUE Executive — King Tech Srls
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
          Payments powered by Stripe
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
